import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvallevels',
  templateUrl: './approvallevels.component.html',
  styleUrls: ['./approvallevels.component.css']
})
export class ApprovallevelsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
